module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAXCAYAAAARIY8tAAAACXBIWXMAAAsSAAALEgHS3X78AAABCklEQVRIie2VwU3DMBSGvyDuRSxAN0gnqMwA3eBJHDkhsUG7Q0+9VdXbgAEIG7SLIDqBOcSlruMkL0E9wS9FUZy875Od5Lnw3nPN3A55WFW3wAxwIvJlqSmsMwjwp3B5ABzwCizD2IeIuLTuZgQcoAQq4K6vtneJEvgxnCdBUvbVd84gA18Az9RLZEqroAW+BjbAi1WSFXTAS+rlectIpqraeCcNQQ/8lJzkAahSyYXACO+SlKnkRzAQbpYU3vux8Di5mgPgTv/BNhwAn8BuADyeyRy4j280WoWqOuB9ADzOo4hU8YC12R2BfTI2pf5yOmMV7NNGpqorzo2uNaZm95v8C/6AwLwnj803syFt4bB/Td4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage.png
// module id = HfyV
// module chunks = 56